export const SIGNATURE_CLASS = "mceNonEditable";

// Matches forced_root_block_attrs in brivity/tinymce.js so these blank lines space
// the same as ones the user creates with Enter.
const BLANK_LINE = '<p style="margin:0;padding:0;"><br></p>';
const LEAD_IN = BLANK_LINE.repeat(2);

// Returns "" for a blank signature; wrapping one leaves an undeletable empty block.
export const wrapSignature = (html) => {
  const signature = (html || "").trim();
  if (!signature) return "";

  return `${LEAD_IN}<div class="${SIGNATURE_CLASS}" data-brivity-signature="true">${signature}</div>`;
};

export default wrapSignature;
